import { useMemo } from 'react';
import { formatCurrency } from '../utils';

const STATUS_PILLS = [
  { key: "Draft", bg: "bg-slate-100", text: "text-slate-600" },
  { key: "Submitted", bg: "bg-amber-100", text: "text-amber-700" },
  { key: "Approved", bg: "bg-green-100", text: "text-green-700" },
  { key: "Rejected", bg: "bg-red-100", text: "text-red-700" },
];

export default function DashboardChangeOrders({ projects, onNavigate }) {
  const { total, statusCounts, netApprovedImpact } = useMemo(() => {
    const counts = { Draft: 0, Submitted: 0, Approved: 0, Rejected: 0 };
    let total = 0, netApproved = 0;
    for (const p of projects) {
      for (const co of (p.changeOrders || [])) {
        total++;
        const status = co.status || "Draft";
        counts[status] = (counts[status] || 0) + 1;
        if (status === "Approved") netApproved += (co.amount || 0);
      }
    }
    return { total, statusCounts: counts, netApprovedImpact: netApproved };
  }, [projects]);

  if (total === 0) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-5">
        <h3 className="text-sm font-semibold text-stone-800 mb-3">Change Orders</h3>
        <p className="text-xs text-slate-400">No change orders across projects.</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5">
      <h3 className="text-sm font-semibold text-stone-800 mb-3">Change Orders</h3>
      <div className="flex items-baseline gap-3 mb-3">
        <p className="text-2xl font-bold text-stone-700">{total}</p>
        <p className="text-xs text-slate-500">across all projects</p>
      </div>
      <div className="flex flex-wrap gap-2 mb-3">
        {STATUS_PILLS.map(sp => statusCounts[sp.key] > 0 && (
          <button key={sp.key}
            onClick={() => onNavigate("change-orders", sp.key)}
            className={`text-xs px-2.5 py-1 rounded-full ${sp.bg} ${sp.text} font-medium cursor-pointer hover:opacity-80 hover:shadow-[0_0_0_2px_rgba(232,160,32,0.3)] transition-all`}>
            {statusCounts[sp.key]} {sp.key}
          </button>
        ))}
      </div>
      <div className="border-t border-slate-100 pt-2">
        <p className="text-xs text-slate-500">Net approved impact</p>
        <p className={`text-sm font-bold ${netApprovedImpact >= 0 ? "text-red-600" : "text-green-600"}`}>
          {netApprovedImpact >= 0 ? "+" : ""}{formatCurrency(netApprovedImpact)}
        </p>
      </div>
    </div>
  );
}
